import { jsx, Fragment } from "react/jsx-runtime";
import { renderMessageContentWithCarousels } from "../../utils/messageRenderer.js";
function TextPart({
  text,
  productMetadataMap,
  onProductClick
}) {
  if (!text.trim()) return null;
  const renderedContent = renderMessageContentWithCarousels(
    text,
    productMetadataMap || /* @__PURE__ */ new Map(),
    /* @__PURE__ */ new Map(),
    false,
    false
  );
  if (renderedContent.length > 0) {
    return /* @__PURE__ */ jsx(Fragment, { children: renderedContent });
  }
  return /* @__PURE__ */ jsx("div", { className: "concierge-text-part", children: text.split("\n\n").map((paragraph, i) => /* @__PURE__ */ jsx("p", { children: paragraph }, i)) });
}
export {
  TextPart
};
//# sourceMappingURL=TextPart.js.map
